export const palette = {
  colors: {
    black_main: "#000000",
    white_main: "#FFFFFF",
    green_base: "#1B6D24",
    green10: "#002204",
    green60: "#53A252",
    green90: "#A3F69C",
    grey_base: "#fcfdf6",
    error: "#BA1A1A",
    button_hover: "#96e58f",
    button_text_hover: "#e6eee3",
    link: "#38656A",
    surface: "#EEEEE8",
    surface_container: "#F3F4EE",
    secondary_container: "#D6E8CE",
    secondary: "#52634F",
    onsurface: "#1A1C19",
    onsurface_variant: "#424940",
    surface_container_high: "#E2E3E2",
    surface_container_highest: "#E2E3DD",
    inverse_onsurface: "#F0F1EB",
    inverse_surface: "#2F312D",
    tertiary_container: "#BCEBF0",
    outline_variant: "#C2C9BD",
    method: {
      GET: "#1A8840",
      POST: "#B08014",
      DELETE: "#922516",
      PUT: "#1660BD",
      HEAD: "#037F31",
      OPTIONS: "#A51468",
      PATCH: "#67399A",
    },
  },
  border: {
    grey: "1px solid #C2C9BD",
    outline: "1px solid #72796F",
  },
};

export const shape = {
  rounding: {
    S: "2px",
    M: "4px",
    L: "16px",
    XL: "24px",
    XXL: "28px",
    XXXL: "100px",
  },
};
